import React, { useMemo } from 'react';
var GenderComponent = function (props) {
    var text = useMemo(function () {
        if (props.value === 1) {
            return '男';
        }
        var text = '-';
        switch (props.value) {
            case 2:
                text = '女';
                break;
            case 1:
                text = '男';
                break;
            default:
                break;
        }
        return text;
    }, [props.value]);
    return (React.createElement("span", { className: props.className, style: props.style }, text));
};
export default React.memo(GenderComponent);
